
import { useEffect, useState } from 'react';
import { supabase } from '../integrations/supabase/client';
import { useAuth } from '../contexts/AuthContext';

interface TrainingSession {
  id: string;
  title: string;
  date: string;
  start_time: string;
  end_time: string;
  description: string | null;
}

export const useTrainingNotifications = () => {
  const { profile } = useAuth();
  const [pendingSession, setPendingSession] = useState<TrainingSession | null>(null);
  const [dialogOpen, setDialogOpen] = useState(false);

  useEffect(() => {
    if (!profile || profile.role !== 'student') return;

    // Listen for new training sessions
    const channel = supabase
      .channel('training-notifications')
      .on(
        'postgres_changes',
        {
          event: 'INSERT',
          schema: 'public',
          table: 'training_sessions'
        },
        (payload) => {
          const newSession = payload.new as TrainingSession;
          setPendingSession(newSession);
          setDialogOpen(true);
        }
      )
      .subscribe();

    return () => {
      supabase.removeChannel(channel);
    };
  }, [profile]);

  const closePendingNotification = () => {
    setDialogOpen(false);
    setPendingSession(null);
  };

  return {
    pendingSession,
    dialogOpen,
    closePendingNotification
  };
};
